module.exports = __webpack_public_path__ + "img/st_logo.6ec8d582.svg";